<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<InventoryNavi />
			<div class="agency-xls-upload">
				<h1>상품엑셀등록</h1>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
					<el-form-item label="엑셀파일: " prop="excle_url">
						<el-upload
						  
						  :action="update_url+'/common/upload'"
						  :on-preview="handlePreview"
						  :on-remove="handleRemove"
						
						  :before-upload="beforeUpload"
						  :limit="1"
						  :on-success="handleSuccess"
						  :file-list="fileList">
						 <!-- <img width="100%" :src="ruleForm.fileList[0].url" alt=""> -->
						
						  <el-button size="small" type="primary">파일선택</el-button>
						  <div slot="tip" class="el-upload__tip">Excel 파일만 업로드할 수 있으며, 1 MB를 초과할 수 없습니다.</div>
						</el-upload>
					</el-form-item>
					<el-form-item>
					    <el-button type="primary" @click="submitForm('ruleForm')">업로드</el-button>
					   
					</el-form-item>

				</el-form>
				<div class="row" >
					<el-row>
						<el-col :xs="24" :sm="4">
							<div style="display: flex;justify-content: center;font-weight: bold; ">
								샘플양식
							</div>
						</el-col>
						<el-col :xs="24" :sm="20">
							<div>
								<el-button round @click="openExcel">다운로드</el-button>
								<!-- <div class="category-guide">
									기타 검수/포장 등 옵션 선택은 엑셀 업로드 완료 후, 마이페이지-상세보기-주문서수정 버튼을 통해 추가해주세요
								</div> -->
							</div>
						</el-col>
					</el-row>

				</div>
				<div class="row" >
					<el-row>
						<el-col :xs="24" :sm="4">
							<div style="display: flex;justify-content: center;font-weight: bold; ">
								HSCODE<br>
								조회
							</div>
						</el-col>
						<el-col :xs="24" :sm="20">
							<el-popover
								placement="bottom-start"
								width="700"
								trigger="click"
								v-model="popoverVisible"
								@show="onCategoryDialog"
								popper-class="category-popper"
							>
								<div class="category-dropdown-content">
									<div style="margin-bottom: 15px;">
										<el-input
											v-model="categorySearch"
											placeholder="분류명, HS Code, 중국어 등으로 검색..."
											clearable
											prefix-icon="el-icon-search"
											size="small"
										></el-input>
									</div>
									<div class="scroller-container">
										<div class="v-table-header">
											<div class="v-col-l1">1차 분류</div>
											<div class="v-col-l2">2차 분류 (HS Code)</div>
											<div class="v-col-l3">3차 분류 (상세)</div>
										</div>
										
										<RecycleScroller
											class="category-v-scroller"
											:items="popoverVisible ? filteredCategories : []"
											:item-size="65"
											key-field="uniqueId"
											v-slot="{ item: catItem }"
										>
											<div class="v-category-row" @click="handleSelectCategory(catItem)" style="cursor: pointer;">
												<div class="v-col-l1">
													<div class="ko" v-html="highlightCategoryText(catItem.l1)"></div>
												</div>
												<div class="v-col-l2">
													<div class="ko">
														<span v-html="highlightCategoryText(catItem.l2)"></span>
														<span class="code">({{' '}}<span v-html="highlightCategoryText(catItem.l2_code)"></span>{{' '}})</span>
													</div>
													<div class="cn" v-if="catItem.l2_cn" v-html="highlightCategoryText(catItem.l2_cn)"></div>
												</div>
												<div class="v-col-l3">
													<div class="ko" v-html="highlightCategoryText(catItem.l3)"></div>
													<div class="code" v-if="catItem.l3_code !== '-'" v-html="highlightCategoryText(catItem.l3_code)"></div>
												</div>
											</div>
										</RecycleScroller>
									</div>
								</div>
								<el-button slot="reference" type="primary" plain round>선택하기</el-button>
							</el-popover>
							
							<div class="category-guide" v-if="category_name && category_code">
								<b style="color:#0055d4;">{{category_name}}</b> 대한 HS CODE는 <b style="color:#f75706; font-size: 18px;">{{category_code}}</b>입니다.
							</div>
							<div class="category-guide" v-else>
								품목분류를 선택하시면 해당 HS CODE를 보실 수 있습니다.
							</div>
						</el-col>
					</el-row>
				</div>
				
			</div>
			
		</div>
		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import InventoryNavi from '../../components/InventoryNavi.vue'
	import request from '@/utils/request'
	import Constants from '@/constants'
	import categoryData from '@/assets/fenlei_final_with_10_names_no_cat4.min.json'
	export default {
		components: {
			BusinessBanner,
			InventoryNavi
		},
		data() {
			return {
				ruleForm: {
					excle_url:'',
				},
				rules: {
					excle_url:[
						{ required: true, message: 'Excel 파일 필수', trigger: 'change' }
					]

				},
				//show:true,
				fileList: [
			
				],
				update_url:'',
				server_url:'',
				CategoryVisible: false,
				category_list:[],
				search: '',
				category_name:"",
				category_code:"",
				flattenedCategories: [],
				categorySearch: '',
				popoverVisible: false,


			}
		},
		computed: {
			isMobile() {
				return window.innerWidth <= 768;
			},
			filteredCategories() {
				if (!this.categorySearch) {
					return this.flattenedCategories
				}
				const query = this.categorySearch.toLowerCase()
				return this.flattenedCategories.filter(item => {
					return (
						(item.l1 && item.l1.toLowerCase().includes(query)) ||
						(item.l2 && item.l2.toLowerCase().includes(query)) ||
						(item.l2_code && item.l2_code.toLowerCase().includes(query)) ||
						(item.l2_cn && item.l2_cn.toLowerCase().includes(query)) ||
						(item.l2_en && item.l2_en.toLowerCase().includes(query)) ||
						(item.l3 && item.l3.toLowerCase().includes(query)) ||
						(item.l3_code && item.l3_code.toLowerCase().includes(query))
					)
				})
			},
		},	
		created() {
			console.log(Constants.BASE_URL) 
			console.log(Constants.SERVER_URL) 
			this.update_url = Constants.BASE_URL
			this.server_url = Constants.SERVER_URL
		},
		methods: {
			onCategoryName(id,name,code){
				console.log(id,name,code,"获取分类")
				this.CategoryVisible = false
				this.category_name =name
				this.category_code =code
			
			},
			onCategoryDialog(){
				this.popoverVisible = true
				if (this.flattenedCategories.length === 0) {
					this.processCategories()
				}
			},
			processCategories() {
				const result = []
				let counter = 0
				categoryData.categories.forEach((cat) => {
					cat.items.forEach((item) => {
						if (item.hscode_10_details && item.hscode_10_details.length > 0) {
							item.hscode_10_details.forEach((h10) => {
								result.push({
									uniqueId: counter++,
									item_id: item.id,
									l1: cat.category_name,
									l2: item.name_ko,
									l2_code: item.hs_code,
									l2_cn: item.name_cn,
									l2_en: item.name_en,
									l3: h10.hscode_10_name,
									l3_code: h10.hscode_10
								})
							})
						} else {
							result.push({
								uniqueId: counter++,
								item_id: item.id,
								l1: cat.category_name,
								l2: item.name_ko,
								l2_code: item.hs_code,
								l2_cn: item.name_cn,
								l2_en: item.name_en,
								l3: '-',
								l3_code: '-'
							})
						}
					})
				})
				this.flattenedCategories = Object.freeze(result)
			},
			highlightCategoryText(text) {
				if (!this.categorySearch || text === undefined || text === null || text === '-') return text
				const str = String(text)
				const query = this.categorySearch.trim().toLowerCase()
				if (!query) return str
				const regex = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
				return str.replace(regex, match => `<span class="hl-text-category">${match}</span>`)
			},
			handleSelectCategory(row) {
				console.log("选择分类:", row)
				this.category_name = row.l2;
				this.category_code = (row.l3_code && row.l3_code !== '-') ? row.l3_code : row.l2_code;
				this.popoverVisible = false;
			},
			openExcel(){
				window.open(this.server_url+"/assets/excel/inventory_upload_sample_ko.xls", '_blank')
			},
			submitForm(formName) {
				this.$confirm('제출하시겠습니까?', '', {
				  confirmButtonText: '확인',
				  cancelButtonText: '취소',
				  type: 'warning'
				}).then(() => {
					
					this.$refs[formName].validate((valid) => {
					  if (valid) {
						console.log(this.ruleForm,"提交表单")
						request.post('/member/Inventory/registerGoodsExcel',
							this.ruleForm
						).then(response => {
							console.log(response,"提交?????")			  
							if(response.code ==1){
								alert(response.msg);
								//console.log('审核！');
									if (this.$route.query.type === 'coupang' || this.$route.query.activeMenu) {
										this.$router.replace({ query: { ...this.$route.query, type: 'coupang', activeMenu: 'coupang_inventory_item' } }).catch(() => {});
									} else {
										this.$router.replace('/inventoryItem').catch(() => {});
									}
						
							}else{
								alert(response.msg)
								return
							}
								
						});
						      

						
					  } else {
						console.log('error submit!!');
						return false;
					  }
					});
				  
				  
				}).catch(() => {
				  this.$message({
					type: 'info',
					message: '已取消删除'
				  });          
				});
				
				
				
			},
			isExcel(file) {
			  const suffix = file.name.split('.').pop().toLowerCase();
			  const mimeTypes = [
			    'application/vnd.ms-excel',
			    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			    'application/vnd.ms-excel.sheet.macroEnabled.12',
			    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
			    'text/csv'
			  ];
			  const suffixes = ['xls', 'xlsx', 'xlsm', 'xlsb', 'csv'];
			  return mimeTypes.includes(file.type) || suffixes.includes(suffix);
			},
			//上传文件之前的钩子
			beforeUpload(file){
				console.log(file,"上传文件之前的钩子")
				const isLt1M = file.size / 1024 / 1024 < 1;
				let isExcel = this.isExcel(file)
				if (!isExcel) {
					this.$message.error('Excel 파일 형식만 업로드할 수 있습니다!');
					return false
				}
				if (!isLt1M) {
					this.$message.error('이미지 업로드 크기는 1MB를 초과할 수 없습니다!');
					return false
				}

			},
			//文件上传成功时的钩子
			handleSuccess(res, file,fileList) {
				console.log(res,11)
				console.log(file,22)
				console.log(fileList,33)
				if(res.code ==1){
					this.fileList=[{name: file.name, url: res.data.fullurl}]
					this.ruleForm.excle_url=res.data.url
					
				}
		
				
			},
			//文件列表移除文件时的钩子
			handleRemove(file, fileList) {
				console.log(file, fileList,"文件列表移除文件时的钩子");
				this.fileList=[]
				this.ruleForm.excle_url=''
			},
			//点击文件列表中已上传的文件时的钩子
			handlePreview(file) {
				console.log(file,"点击文件列表中已上传的文件时的钩子");
				window.open(file.url, '_blank')
			},


		}
	}
</script>

<style scoped>
	.agency-xls-upload h1{
		font-size: 36px;
		font-weight: bold;
		text-align: center;
		margin-top: 2px;
		margin-bottom: 50px;
	}
	.agency-xls-upload .category-guide {
	    padding: 15px 15px;
		color:#606266;
	    font-weight: 500;
	    font-size: 15px;
	    max-height: 80px;
		margin-top: 10px;
	}
	.row{
		margin-top: 30px;padding-top: 10px; border-top: 1px solid #ccc;
	}
	/* 分类弹框 */
	.agency-category-customs{
		display: flex;
	}
	.agency-category-customs .type-general{
		background-color: #0055d4;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.agency-category-customs .type-list{
		background-color: #c33;
		width: 18px;
		height: 18px;
		border-radius: 6px;
		margin: 0 5px 0 15px;
	}
	.help-block{
	    background-color: #d5e6fa;
	    color: #274780;
	    display: flex;
	    min-height: 40px;
		padding:5px 0;
	    border-radius: 12px;
	    align-items: center;
	    padding-left: 19px;
	    margin: 17px 0 20px;
	}
	.agreement-box{
		border: 1px solid var(--border-color);
	/* 	background: #F5F8FD; */
		padding: 15px;
		margin: 25px 0 5px;
		border-radius: 20px;
	}
	.height-fixed-box{
		/* background: #F5F8FD; */
		height: 400px;
		overflow-y: scroll;
		padding-right: 20px;
		font-size: 12px;
		color: #333;
	}
	.height-fixed-box ol {
	    margin: 0;
	    padding: 0;
	}
	.height-fixed-box .depth1 {
	    border: 1px solid #e5e5e5;
	    border-radius: 13px;
	    margin-bottom: 20px;
	}
	.height-fixed-box li {
	    margin: 0 0 30px 0;
	    padding: 0;
	    list-style: none;
	}
	.height-fixed-box li li {
	    display: inline-flex;
	    align-items: center;
	    margin: 0;
	    padding: 3px 5px;
	    width: 30%;
	    font-size: 13px;
	}
	.height-fixed-box li strong.namecolor-blue {
	    background-color: #0055d4;
	    border-top-left-radius: 8px;
	    border-top-right-radius: 8px;
	    padding: 9px 25px 6px;
	    font-size: 15px;
	    margin-bottom: 0;
	}
	.height-fixed-box li strong {
	    display: block;
	    background: #666;
	    color: #fff;
	    font-weight: 500;
	}
	.height-fixed-box .name{
		cursor: pointer;
	}
	.height-fixed-box .name:hover{
		text-decoration: underline; /* 悬停时添加下划线 */
	}
	.flex{
		display: flex;
	}
	.color-blue {
	    color: #0055d4 !important;
	}
	.color-red {
	    color: #cc3333 !important;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 992px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:40px 10px;
		}
		.agency-xls-upload h1{
			font-size: 28px;
		}
	
	}

	/* 分类虚拟下拉样式 */
	.category-popper {
		max-width: 100vw;
		padding: 0 !important;
	}
	.category-dropdown-content {
		padding: 15px;
		background: #fff;
	}
	.scroller-container {
		border: 1px solid #eee;
		border-radius: 8px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		height: 400px;
	}
	.v-table-header {
		display: flex;
		background-color: #f0f7ff;
		height: 40px;
		align-items: center;
		padding: 0 15px;
		font-weight: bold;
		color: #0055d4;
		font-size: 13px;
		border-bottom: 1px solid #d0e3f7;
	}
	.category-v-scroller {
		flex: 1;
	}
	.v-category-row {
		display: flex;
		align-items: center;
		padding: 0 15px;
		height: 65px;
		border-bottom: 1px solid #f5f5f5;
		box-sizing: border-box;
	}
	.v-category-row:hover {
		background-color: #fafafa;
	}
	.v-col-l1 { width: 120px; flex-shrink: 0; color: #0055d4; font-weight: bold; font-size: 13px; }
	.v-col-l2 { width: 220px; flex-shrink: 0; padding: 0 10px; display: flex; flex-direction: column; justify-content: center; }
	.v-col-l3 { flex: 1; min-width: 0; padding-left: 10px; display: flex; flex-direction: column; justify-content: center; }
	
	.v-category-row .ko { font-size: 13px; color: #333; margin-bottom: 2px; }
	.v-category-row .cn { font-size: 11px; color: #e67e22; font-weight: 500; }
	.v-category-row .code { color: #999; font-family: monospace; font-size: 11px; }

	::v-deep .hl-text-category {
		background-color: #fffb8f;
		color: #f5222d;
		font-weight: bold;
		padding: 0 2px;
		border-radius: 2px;
	}
</style>